import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import AxiosInstance from "../../components/Axios";
import {MRT_ColumnFiltersState, MRT_PaginationState, MRT_SortingState} from "material-react-table";
import {
    DipProg, DipProgApiResponse,
    DipProgDTOApiResponse,
    mapDipProgToJson,
    mapJsonToDipProg, mapJsonToDipProgApiResponse,
    mapJsonToDipProgDTOApiResponse,
} from "./types";
import {columnFiltersParamWithDateRange, sortingParam} from "../../common/Services";
import * as Yup from "yup";
import {
    DipendentiApiResponse,
    mapJsonToDipendentiApiResponse,
    mapJsonToProgettiApiResponse,
    ProgettiApiResponse
} from "../gestversore/types";

export function useGetDipProgDTO(
    pagination: MRT_PaginationState,
    columnFilters: MRT_ColumnFiltersState,
    globalFilter: string,
    sorting: MRT_SortingState,
 ) {
    return useQuery<DipProgDTOApiResponse>({
        queryKey: [
            'fetchDipProgDTO',
            columnFilters, // refetch when columnFilters changes
            globalFilter,  // refetch when globalFilter changes
            pagination.pageIndex, // refetch when pagination.pageIndex changes
            pagination.pageSize, // refetch when pagination.pageSize changes
            sorting, // refetch when sorting changes
        ],
        queryFn: async () => {
            // Get isAdmin and coddip from localStorage at the start


            const coddip = localStorage.getItem('coddip') || '';
            const keyrole = localStorage.getItem('keyrole') || '';
            const isAdmin = keyrole.includes('TimeReportAdmin') || coddip === 'DS';




                // if (role === 'TimeReportUser') {
                //       coddip = localStorage.getItem('coddip') || 'NN';
                // }

                // if (role === 'TimeReportCust') {
                //     coddip = 'NN';
                // }
                //
                // if (role === 'TimeReportAdmin') {
                //     if (impcoddip === 'NN' || impcoddip === '') {
                //         coddip = '';
                //     } else {
                //         coddip = impcoddip;
                //     }
                // }

                // if (coddip === 'DS') {
                //     coddip = '';
                // }

            const myLimit=pagination.pageSize
            const myOffset =
                pagination.pageIndex === 0
                    ? '0'
                    : `${pagination.pageSize * pagination.pageIndex}`;


            let myURL = `?limit=${myLimit}&offset=${myOffset}&search=${globalFilter ?? ''}${columnFiltersParamWithDateRange(
                columnFilters,
                'VBT12'
            )}&ordering=${sortingParam(sorting, 'VBT12')}`;

            if (!isAdmin) {
                        myURL += `&VBT12_REF=${coddip}`;
                }




            const response = await AxiosInstance.get(`dipprogdto/${myURL}`);

            return mapJsonToDipProgDTOApiResponse(response.data);
        },
        refetchOnWindowFocus: false,
    });
}


export function useGetDipProgDTObyProg(codprog: string) {
  return useQuery<DipProgDTOApiResponse>({
    queryKey: ['fetchDipProgDTO',codprog],
    queryFn: async () => {
        const response = await AxiosInstance.get('dipprogdto/?limit=50000&offset=0&VBT12_CODPROG='+codprog);
        return mapJsonToDipProgDTOApiResponse(response.data)
    },
    refetchOnWindowFocus: false,
  });
}
export function useGetDipProgById(id: string) {
  return useQuery<DipProg>({
    queryKey: ['fetchDipProg', id],
    queryFn: async () => {
console.log("ID passed:", id);
      const response = await AxiosInstance.get('dipprog/?limit=1000&offset=0&BT12_ID__exact='+id);
      const item = response.data.results?.[0];
      if (!item) {
        throw new Error("DipProg non trovato");
      }
     return mapJsonToDipProg(item);
    },
    refetchOnWindowFocus: false,
  });
}


export function useCreateDipProg() {
  const queryClient = useQueryClient();
  return useMutation({

    mutationFn: async (dipprog: DipProg) => {

       const response = await AxiosInstance.post('dipprog/0/', mapDipProgToJson(dipprog));
       return response.data;

      // return AxiosInstance.post('dipprog/0/',mapDipProgToJson(dipprog));
    },

     onSuccess: async (data, variables) => {

       queryClient.invalidateQueries({ queryKey: ['fetchDipProgDTO'] });

   }, //refetch VersoOre after mutation, disabled for demo
     });
}

export function useUpdateDipProg() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (dipprog: DipProg) => {
      const response = await AxiosInstance.patch(`dipprog/${dipprog.id}/`, mapDipProgToJson(dipprog));
      return response.data;
    },
    onSuccess: async () => {
      queryClient.invalidateQueries({ queryKey: ['fetchDipProgDTO'] });
    },
  });
}



export function useDeleteDipProg() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
    const response = await AxiosInstance.delete('dipprog/'+id+'/');
     return  response.data
    },
     onSuccess: async (data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['fetchDipProgDTO'] });
    },
  });
}

export function useBulkCreateDipProg() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (items: DipProg[]) => {
      const response = await AxiosInstance.post(
        'dipprogbulk/bulkcreate/',
        {
          items: items.map(mapDipProgToJson),
        }
      );
     return response.data;
    },
    onSuccess: async () => {
      queryClient.invalidateQueries({
        queryKey: ['fetchDipProgDTO'],
      });
    },
  });
}

export function useBulkDeleteDipProg() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (ids: string[]) => {
      const response = await AxiosInstance.post('dipprogbulk/bulkdelete/',{ ids });
      return response.data;
    },
    onSuccess: async () => {
      queryClient.invalidateQueries({
        queryKey: ['fetchDipProgDTO'],
      });
    },
  });
}










export const validationSchema = Yup.object().shape({
                      // fromDate: Yup.date().required('Selezione Data Inizio'),
                      // toDate: Yup.date().test('is-after-or-equal', 'La data di fine deve essere successiva alla data di inizio', function (value) {
                      //                    const { fromDate } = this.parent; // Access fromDate from parent object
                      //                    if (!fromDate || !value) {
                      //                    return true; // Skip validation if fromDate or toDate is not set
                      //                 }
                      //                 return fromDate <= value; // Validate if toDate is after or equal to fromDate
                      //               }),
                      emailTo: Yup.string().email('Email non è valida'),
                    });


